import { asExamId, type ExamId } from "@repo/domain";
import { z } from "zod";
import { newEntityIdSchema } from "./entity-id.schemas";
import { practitionerIdSchema } from "./practitioner.schemas";
import { visitIdSchema } from "./visit.schemas";

export const examIdSchema: z.ZodType<ExamId, z.ZodTypeDef, string> = z.string().min(1).transform(asExamId);
export const addExamFromVisitExternalInputSchema = z.object({
  id: newEntityIdSchema,
  visitId: visitIdSchema,
  definitionUrl: z.string().url(),
  expectedVersion: z.number().int().positive(),
});
export const addExamFromVisitInputSchema = addExamFromVisitExternalInputSchema;
export type AddExamFromVisitInput = z.infer<typeof addExamFromVisitInputSchema>;
export type AddExamFromVisitParams = z.input<typeof addExamFromVisitExternalInputSchema>;
export const closeOutExamExternalInputSchema = z.object({
  examId: examIdSchema,
  visitId: visitIdSchema,
  confirmedDidNotPerform: z
    .array(
      z.object({
        id: newEntityIdSchema,
        definitionUrl: z.string().url(),
        expectedVersion: z.number().int().positive(),
        comment: z.string().optional(),
      }),
    )
    .optional(),
  prerequisiteCascade: z
    .array(
      z.object({
        definitionUrl: z.string().url(),
        expectedVersion: z.number().int().positive(),
        id: newEntityIdSchema,
      }),
    )
    .refine((entries) => new Set(entries.map((entry) => entry.definitionUrl)).size === entries.length, {
      message: "A finding can be cascaded only once",
    })
    .optional(),
});
export const closeOutExamInputSchema = closeOutExamExternalInputSchema.extend({ clinician: practitionerIdSchema });
export type CloseOutExamInput = z.infer<typeof closeOutExamInputSchema>;
